var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 98,
    viewBox: "0 0 100 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1448 93.5792C75.3416 93.5792 95.7676 73.5318 95.7676 48.8021C95.7676 24.0724 75.3416 4.02497 50.1448 4.02497C24.948 4.02497 4.52197 24.0724 4.52197 48.8021C4.52197 73.5318 24.948 93.5792 50.1448 93.5792Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0638 30.412C37.8301 26.9322 58.6277 24.8953 76.8525 40.0877M29.8941 45.7685C43.5159 40.321 58.1952 44.9466 67.1239 53.7735C67.1239 53.7735 57.8051 46.2363 50.5777 44.4947C42.7178 42.6006 29.8941 45.7685 29.8941 45.7685ZM32.6847 61.3908C40.9432 57.5503 53.4822 59.3538 57.3953 67.4593C57.3953 67.4593 51.5551 61.2429 46.5397 59.9183C41.2843 58.5302 32.6847 61.3908 32.6847 61.3908Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.e80c964637eeef600fda6eb9dfcbd98d.svg";
export { ForwardRef as ReactComponent };